import { Static, Object, String, Array } from '@sinclair/typebox';

export const TravelPassShareBookingRequest = Object({
  pnr: String(),
  recipients: Array(String()),
});
export type TravelPassShareBookingRequest = Static<typeof TravelPassShareBookingRequest>;
